import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 12, viewBox: "0 0 7 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 0 2.357 12H0L4.643 0H7z", fill: "#DFDFDF" }));
export default SvgSlash;
